import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaVerificationMetricAssociationPropertyValidation {
    VERIFICATION_METRIC = 'VERIFICATION_METRIC',
}

export const ProcessAreaVerificationMetricAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION),
    verificationMetric: IdSchema,
});
export const ProcessAreaVerificationMetricAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaVerificationMetricAssociationResourceSchema
);

export type ProcessAreaVerificationMetricAssociationResource = z.infer<
    typeof ProcessAreaVerificationMetricAssociationResourceSchema
>;

export const defaultProcessAreaVerificationMetricAssociationResource: ProcessAreaVerificationMetricAssociationResource =
    {
        ...defaultIndirectlyVersionedArtifactResource,
        resourceType: ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION,
        verificationMetric: '',
    };

export function useProcessAreaVerificationMetricAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-verification-metric-association',
            ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION,
            ProcessAreaVerificationMetricAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-verification-metric-association',
            ResourceType.PROCESS_AREA_VERIFICATION_METRIC_ASSOCIATION,
            ProcessAreaVerificationMetricAssociationResourceSchema
        ),
    };
}
